import protoRoot from '@/proto/data_view_pb.js';

export function sendAuthInfo(recordName, timestamp = 0, channelList) {
  var playData = new protoRoot.PlayData();
  playData.setFrameSyncFlag(true);
  if (arguments.length === 3) {
    playData.setRecordName(recordName);
    playData.setStartTimestamp(timestamp);
    playData.setBlacklistChannelList(channelList);
  } else {
    playData.setBlacklistChannelList(recordName);
  }

  // playData.setStopFlag(true);
  // playData.setPlaySpeed(1);
  var dataSessionProtocal = new protoRoot.DataSessionProtocal();
  dataSessionProtocal.setPlayData(playData);
  var bytes = dataSessionProtocal.serializeBinary();
  return bytes;
}



export function buildRequestDataToBytes(
  id,
  Interface,
  paramsMap,
  timestam = 0,
) {
  let requestData = new protoRoot.RequestData();
  requestData.setId(id);
  requestData.setInterface(Interface);
  requestData.setRequestTimestamp(new Date().getTime());
  paramsMap.forEach((val, key) => {
    requestData.getParamsMap().set(key, val);
  });
  var dataSessionProtocal = new protoRoot.DataSessionProtocal();
  dataSessionProtocal.setRequestData(requestData);
  var bytes = dataSessionProtocal.serializeBinary();
  return bytes;
}
/**
 * 通过enum的value或者name
 * @param {string} model Enum的名称；比如proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode  传递 Vehicle.DrivingMode 即可
 * @param {number} value enmu的值
 * @returns  enum的name；
 */
export function getNameByValueForEnum(model, value) {
  let modelObj = new Function(
    `return proto.zelos.zoe.data_view.proto.${model}`,
  )();
  for (let key in modelObj) {
    if (modelObj[key] == value) {
      return key;
    }
  }
  return 'UNKNOWN';
}

export function getMessage(data) {
  let message = protoRoot.DataSessionProtocal.deserializeBinary(data);
  return message;
}
export function getMessageData(message) {
  let messageObject = message.getMessageData().toObject();
  messageObject.context = JSON.parse(messageObject.context);
  return messageObject.context;
}

export function getMetaData(message) {
  return message.getMetaData().toObject();
}

export function getFrameData(message) {
  let frameDataList = []
  message.getFrameData().getFrameDataList().forEach(item => {
    let object = {};
    object.timestamp = item.getTimestamp();
    object.createTimestamp = item.getCreateTimestamp();
    if (item.getVehicleData() && item.getVehicleData().length > 0) {
      let vehicleData_obj = protoRoot.VehicleData.deserializeBinary(item.getVehicleData_asB64())?.toObject();
      if (vehicleData_obj.isNewProtocol) {
        object.vehicleData = buildIntTofloat(vehicleData_obj);
      } else {
        object.vehicleData = vehicleData_obj
      }
    }
    if (item.getMapData()) {
      object.mapData = protoRoot.MapData.deserializeBinary(item.getMapData_asB64())?.toObject()
    }
    object.abnormalInfos = item.getAbnormalInfos();
    object.vehicleSignal = item.getVehicleSignal()?.toObject();
    object.vehicleBumper = item.getVehicleBumper()?.toObject();
    // 服务端透传的 serverTime/clientTime，用于旗子时间对齐
    object.extraInfo = item.getExtraInfo();
    frameDataList.push(object);
  })
  return frameDataList;
}

export function getResponseData(message) {
  return message.getResponseData()?.toObject();
}

function buildIntTofloat(vehilceData) {
  try {
    if (vehilceData) {
      /////
      if (vehilceData.origin) {
        vehilceData.origin.x = vehilceData.origin.xInt / 1000;
        vehilceData.origin.y = vehilceData.origin.yInt / 1000;
        vehilceData.origin.z = vehilceData.origin.zInt / 1000;
      }
      if (vehilceData.vehicle?.orientation) {
        vehilceData.vehicle.orientation.x = vehilceData.vehicle?.orientation.xInt / 1000;
        vehilceData.vehicle.orientation.y = vehilceData.vehicle?.orientation.yInt / 1000;
        vehilceData.vehicle.orientation.z = vehilceData.vehicle?.orientation.zInt / 1000;
      }
      if (vehilceData.vehicle) {
        vehilceData.vehicle.velocity = vehilceData.vehicle.velocityInt / 1000;
        vehilceData.vehicle.steerAngle = vehilceData.vehicle.steerAngleInt / 1000;
        vehilceData.vehicle.acceleration = vehilceData.vehicle.accelerationInt / 1000;
      }

      //planning
      vehilceData.planning?.pathList?.forEach(p => {
        p.x = p.xInt / 1000
        p.y = p.yInt / 1000
        p.z = p.zInt / 1000;
      })
      vehilceData.planning?.trajectoryList?.forEach(p => {
        p.x = p.xInt / 1000
        p.y = p.yInt / 1000
        p.z = p.zInt / 1000;
      })
      vehilceData.planning?.parkingNodeList?.forEach(item => {
        if (item.center?.position) {
          item.center.position.x = item.center.position.xInt / 1000;
          item.center.position.y = item.center.position.yInt / 1000;
          item.center.position.z = item.center.position.zInt / 1000;
        }
        if (item.center.orientation) {
          item.center.orientation.x = item.center.position.xInt / 1000;
          item.center.orientation.y = item.center.position.yInt / 1000;
          item.center.orientation.z = item.center.position.zInt / 1000;
        }
      })
      if (vehilceData.planning?.openspaceGoal?.position) {
        vehilceData.planning.openspaceGoal.position.x = vehilceData.planning?.openspaceGoal?.position?.xInt / 1000;
        vehilceData.planning.openspaceGoal.position.y = vehilceData.planning?.openspaceGoal?.position?.yInt / 1000;
      }
      if (vehilceData.planning?.openspaceGoal) {
        vehilceData.planning.openspaceGoal.heading = vehilceData.planning.openspaceGoal.headingInt / 1000;
      }

      vehilceData.planning?.virtualObstacleList?.forEach(item => {
        if (item.centerPosition) {
          item.centerPosition.x = item.centerPosition.xInt / 1000
          item.centerPosition.y = item.centerPosition.yInt / 1000
          item.centerPosition.z = item.centerPosition.zInt / 1000
        }
        item.heading = item.headingInt / 1000;
        item.length = item.lengthInt / 1000;
        item.width = item.widthInt / 1000;
        item.height = item.heightInt / 1000;
      })
      vehilceData.planning?.virtualObstaclesList?.forEach(virtualObstacles_item => {
        virtualObstacles_item?.polygon?.polygonPointList?.forEach(item => {
          item.x = item.xInt / 1000;
          item.y = item.yInt / 1000;
        })
      })


      //routing
      vehilceData.routing?.routingLineList?.forEach(p => {
        p.x = p.xInt / 1000;
        p.y = p.yInt / 1000;
        p.z = p.zInt / 1000;
      })
      if (vehilceData.routing?.spot?.stopSpot) {
        vehilceData.routing.spot.stopSpot.angle = vehilceData.routing.spot.stopSpot.angleInt / 1000;
        vehilceData.routing.spot.stopSpot.mapX = vehilceData.routing.spot.stopSpot.mapXInt / 1000;
        vehilceData.routing.spot.stopSpot.mapY = vehilceData.routing.spot.stopSpot.mapYInt / 1000;
      }
      vehilceData.routing?.spot?.parkingSpotList?.forEach(item => {
        item.angle = item.angleInt / 1000;
        item.mapX = item.mapXInt / 1000;
        item.mapY = item.mapYInt / 1000;
      })
      vehilceData.routing?.subRoutingLineList?.forEach(item => {
        item.routingLineList?.forEach(p => {
          p.x = p.xInt / 1000;
          p.y = p.yInt / 1000;
          p.z = p.zInt / 1000;
        })
      })
      vehilceData.routing?.motorRoutingLineList?.forEach(item => {
        item.routingLineList?.forEach(p => {
          p.x = p.xInt / 1000;
          p.y = p.yInt / 1000;
          p.z = p.zInt / 1000;
        })
      })


      ///
      vehilceData.trafficLightList?.forEach(item => {
        if (item.position) {
          item.position.x = item.position.xInt / 1000;
          item.position.y = item.position.yInt / 1000;
          item.position.z = item.position.zInt / 1000;
        }
        item.angle = item.angleInt / 1000;
        item.remainingSecs = item.remainingSecsInt / 1000;
        item.duration = item.durationInt / 1000;
      })

      //obstacles
      vehilceData.obstacleList?.forEach(obstacle => {
        //Point2D
        obstacle.polygon.pointList?.forEach(item => {
          item.x = item.xInt / 1000;
          item.y = item.yInt / 1000;
        })
        if (obstacle.polygon?.center?.position) {
          obstacle.polygon.center.position.x = obstacle.polygon.center.position.xInt / 1000;
          obstacle.polygon.center.position.y = obstacle.polygon.center.position.yInt / 1000;
          obstacle.polygon.center.position.z = obstacle.polygon.center.position.zInt / 1000;
        }
        if (obstacle.polygon?.center?.orientation) {
          obstacle.polygon.center.orientation.x = obstacle.polygon.center.orientation.xInt / 1000;
          obstacle.polygon.center.orientation.y = obstacle.polygon.center.orientation.yInt / 1000;
          obstacle.polygon.center.orientation.z = obstacle.polygon.center.orientation.zInt / 1000;
        }
        obstacle.preTrajectoryList?.forEach(item => {
          item.trajectoryPointList?.forEach(p => {
            if (p.point) {
              p.point.x = p.point.xInt / 1000;
              p.point.y = p.point.yInt / 1000;
              p.point.z = p.point.zInt / 1000;
            }
            p.relativeTime = p.relativeTimeInt / 1000
          })
          item.probability = item.probabilityInt / 1000
        })
        obstacle.trajectoryList?.forEach(p => {
          p.x = p.xInt / 1000;
          p.y = p.yInt / 1000;
          p.z = p.zInt / 1000;
        })
        obstacle.length = obstacle.lengthInt / 1000;
        obstacle.width = obstacle.widthInt / 1000;
        obstacle.height = obstacle.heightInt / 1000;
        obstacle.speed = obstacle.speedInt / 1000;
        obstacle.speedHeading = obstacle.speedHeadingInt / 1000;
      })

      //

      if (vehilceData.controlDebugData) {
        vehilceData.controlDebugData.vehicleThrottle = vehilceData.controlDebugData.vehicleThrottleInt / 1000;
        vehilceData.controlDebugData.vehicleBrake = vehilceData.controlDebugData.vehicleBrakeInt / 1000;
        vehilceData.controlDebugData.vanguardBrake = vehilceData.controlDebugData.vanguardBrakeInt / 1000;
      }
      vehilceData.metricDataFrameList?.forEach(item => {
        let scaleFactor=item.scaleFactor||1000;
        item.metricLineDataList?.forEach(c => {
          c.metricPointDataList?.forEach(p => {
            p.x = item.timestamp
            p.y = p.yInt / scaleFactor
          })
        })
      })
      //
      if (vehilceData.localization?.linearAcceleration) {
        vehilceData.localization.linearAcceleration.x = vehilceData.localization.linearAcceleration.xInt / 1000;
        vehilceData.localization.linearAcceleration.y = vehilceData.localization.linearAcceleration.yInt / 1000;
        vehilceData.localization.linearAcceleration.z = vehilceData.localization.linearAcceleration.zInt / 1000;

      }
      if (vehilceData.localization?.linearVelocity) {
        vehilceData.localization.linearVelocity.x = vehilceData.localization.linearVelocity.xInt / 1000;
        vehilceData.localization.linearVelocity.y = vehilceData.localization.linearVelocity.yInt / 1000;
        vehilceData.localization.linearVelocity.z = vehilceData.localization.linearVelocity.zInt / 1000;

      }
      if (vehilceData.localization?.gpsPose) {
        vehilceData.localization.gpsPose.x = vehilceData.localization.gpsPose.xInt / 1000;
        vehilceData.localization.gpsPose.y = vehilceData.localization.gpsPose.yInt / 1000;
        vehilceData.localization.gpsPose.z = vehilceData.localization.gpsPose.zInt / 1000;
      }

      //
      vehilceData.trackList?.movableGateList?.forEach(item => {
        if (item.startPosition) {
          item.startPosition.x = item.startPosition.xInt / 1000;
          item.startPosition.y = item.startPosition.yInt / 1000;
          item.startPosition.z = item.startPosition.zInt / 1000;
        }
        if (item.endPosition) {
          item.endPosition.x = item.endPosition.xInt / 1000;
          item.endPosition.y = item.endPosition.yInt / 1000;
          item.endPosition.z = item.endPosition.zInt / 1000;
        }
      })
      //
      vehilceData.trackList?.trafficSignList?.forEach(item => {
        if (item.location) {
          item.location.x = item.location.xInt / 1000;
          item.location.y = item.location.yInt / 1000;
          item.location.z = item.location.zInt / 1000;
        }
      })

      //    
      vehilceData.shieldOutput?.path?.pathPointList?.forEach(item => {
        item.x = item.xInt / 1000;
        item.y = item.yInt / 1000;
        item.z = item.zInt / 1000;
      })
      vehilceData.shieldOutput?.emergencySteering?.path?.pathPointList?.forEach(item => {
        item.x = item.xInt / 1000;
        item.y = item.yInt / 1000;
        item.z = item.zInt / 1000;
      })

      //localmap
      vehilceData.localMap?.stopLineList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })
      vehilceData.localMap?.boundaryList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })
      vehilceData.localMap?.crossWalkList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })
      vehilceData.localMap?.roadMarkList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })
      vehilceData.localMap?.speedBumpList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })
      
      vehilceData.localMap?.laneList?.forEach(item => {
        item.pointList.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000;
        })
      })

      vehilceData.localMap?.localNaviLineList?.forEach(item => {
        item.pointList?.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000
        })
      })

      vehilceData.localMap?.entryLineList?.forEach(item => {
        item.pointList?.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.z = p.zInt / 1000
        })
      })

      //pncBusinessInfosList  10 item  gatePosePointList
      //  if(constructionAreaList

      vehilceData.businessResult?.remoteBusinessCommand?.pncBusinessInfosList?.forEach(item => {   
        item.gatePosePointList?.gatePoseList?.forEach(p => {
          p.x = p.xInt / 1000
          p.y = p.yInt / 1000
          p.theta = p.thetaInt / 1000;
        })
      })

      vehilceData.businessResult?.remoteBusinessCommand?.pncBusinessInfosList?.forEach(item => {
        item.constructionAreaList?.constructionAreasList?.forEach(virtualObstacles_item => {
          virtualObstacles_item?.polygon?.polygonPointList?.forEach(item => {
            item.x = item.xInt / 1000;
            item.y = item.yInt / 1000;
          })
        })
      })

      const freeMoveCommand = vehilceData.businessResult?.remoteBusinessCommand?.remoteTakeoverCommand?.freeMoveCommand;
      [freeMoveCommand?.historyPreview?.environmentEdit, freeMoveCommand?.preview?.environmentEdit].forEach(edit => {
        edit?.eraseObstacleAreasList?.forEach(area => {
          area.pointList?.forEach(p => {
            p.x = p.xInt / 1000;
            p.y = p.yInt / 1000;
          })
        })
      })
      return vehilceData
    } else {
      return null;
    }
  } catch (ex) {
    console.log(ex);
  }
}